export function setSections(state, sections) {
  state.sections = Array.isArray(sections) ? sections : [];
}
